export const validateWriteAccess = (sidebarResource, resourceName, featureName) => {
    if (Object.entries(sidebarResource).length !== 0 && sidebarResource !== undefined) {
        if (sidebarResource[resourceName] !== undefined && sidebarResource[resourceName] !== null) {
            return sidebarResource[resourceName][0]?.permission?.write;
        }
    }
    return false;
};

export const validateDeleteAccess = (sidebarResource, resourceName, featureName) => {
    if (Object.entries(sidebarResource).length !== 0 && sidebarResource !== undefined) {
        if (sidebarResource[resourceName] !== undefined && sidebarResource[resourceName] !== null) {
            return sidebarResource[resourceName][0]?.permission?.delete;
        }
    }
    return false;
};
